<template>
  <span v-if="dataSource.id">
    <a-space>
      <a-button v-for="(item, index) in actionList" :key="index" type="primary" :loading="loading[item.node_id]" @click="onChange(item.node_id)">
        {{ documentStatus[item.node_id][item.actionType] }}
      </a-button>
      <a-button v-if="[4, 5].includes(dataSource.status)" :disabled="dataSource.read === true" type="primary" @click="onRead()">已读</a-button>
    </a-space>
    <action-record-modal ref="actionRecordRef" />
  </span>
</template>

<script>
import { documentStatus } from '@/utils/dictionary';
import { updateDocument, addActionRecord } from '@/api/business/document';

import ActionRecordModal from '@/pages/business/document/components/ActionRecordModal';

export default {
  components: { ActionRecordModal },
  props: {
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    },
    nextStatus: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      loading: {},
      documentStatus
    };
  },
  computed: {
    actionList() {
      return this.nextStatus.filter(item => documentStatus[item.node_id] && documentStatus[item.node_id][item.actionType]);
    }
  },
  methods: {
    onReadRecord(record) {
      this.$refs.actionRecordRef.onOpen(record.id);
    },

    onChange(value) {
      this.$set(this.loading, value, true);
      updateDocument({ id: this.dataSource.id, status: value })
        .then(() => {
          this.$set(this.loading, value, false);
          this.$message.success('状态更新成功');
          this.$emit('ok');
        })
        .catch(() => {
          this.$set(this.loading, value, false);
        });
    },

    onRead() {
      const self = this;
      this.$confirm({
        title: '确认',
        content: '确认要将该MRD文档标记为已读吗?',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        async onOk() {
          addActionRecord({
            targetId: self.dataSource.id,
            targetType: 'mrd',
            actionType: 'read'
          }).then(() => {
            self.$message.success('标记已读成功');
            self.$emit('ok');
          });
        }
      });
    }
  }
};
</script>
